<app-loader-circles *ngIf="showLoader"></app-loader-circles>
<app-new-modal-message #modalAvisos [showFecharBtn]="false"></app-new-modal-message>
<form [formGroup]="identificacaoForm" class="forms">
  <div class="row">
    <div class="row info-container white-box">
      <h2>Demais dados</h2>
      <app-panel-custom [title]="'Biometria - Foto do Cliente'" [color]="'blue'">
        <div class="panel-content">
          <webcam
              [width]="500"
              [trigger]="webcamTrigger"
              *ngIf="hasWebcam && showWebcam"
              (imageCapture)="handleImageCapture($event)"
              (initError)="handleErroWebcam($event)"></webcam>
          <img
              [src]="selfiePreview"
              width="500px"
              *ngIf="!showWebcam && imagemAtualSubject.value"
              style="border-radius: 10px"
              alt="Imagem atual.">
          <div class="btn-tirar-foto" *ngIf="hasWebcam && showWebcam">
            <app-btn-small
                color="primary"
                title="Tirar uma foto"
                (click)="onClickTirarUmaFoto()"
                [isDisabled]="!isEnabledFotoAndEnviar()">
              <em class="fa fa-camera"></em>
            </app-btn-small>
          </div>
          <div class="btn-tirar-foto" *ngIf="!showWebcam && !isAceitaImagem" style="padding-top: 0">
            <app-btn-small
                color="blue"
                title="Trocar foto"
                (click)="onClickTirarOutraFoto()"
                [isDisabled]="!isEnabledFotoAndEnviar()">
              <em class="fa fa-camera"></em>
            </app-btn-small>
          </div>
          <div class="panel-content" *ngIf="!hasWebcam">
            <p class="text-vermelho" style="padding: 0">
              {{ textoErroWebcam }}
            </p>
          </div>

          <div class="btn-tirar-foto">
            <a class="text-center text-orange underline" (click)="selfieInput.click()">
              Não foi possível fotografar o cliente?<br>
              <em class="fa fa-file-image-o"></em>
              Clique aqui para anexar a foto.
            </a>
          </div>

          <div class="box gray-box" style="width: 100%" *ngIf="hasWebcam && !isAceitaImagem">
            <div class="box-title">Dicas de captura</div>
            <ul class="box-content">
              <li>Manter distância máxima de 40cm da câmera.</li>
              <li>Estar enquadrado na tela.</li>
              <li>Não realizar expressão facial, por exemplo, sorrir.</li>
              <li>Não utilizar acessórios, como: óculos, boné, gorro, etc.</li>
            </ul>
          </div>
        </div>

        <span class="hidden">
            <input
              #selfieInput
              type="file"
              (change)="selecionarSelfieManual($event)"
              [accept]="acceptImages"
            />
          </span>
    </app-panel-custom>

      <app-panel-custom [title]="'Documentos Opcionais'" [color]="'blue'" *ngIf="!isMicrocredito">
        <div class="panel-content">
          <span style="display: none">
            <input
                #fileInput
                type="file"
                multiple
                (change)="onFileSelected($event)"
                accept=".gif,.jpg,.jpeg,.png,.bmp,.pdf">
          </span>
          <div class="input-group input-file">
            <app-btn-small
                color="primary"
                title="Selecionar arquivo"
                type="button"
                (click)="onSelecionarDocumentosClick()"
                [isDisabled]="isFullDocumentos"></app-btn-small>
          </div>
          <div class="btn-documento" title="Adicionar novo documento" *ngIf="false">
            <em class="fa fa-plus btn-documento-icon"></em>
            <span class="btn-documento-content">Adicionar documento</span>
          </div>
          <div class="arquivos-enviados" style="color: #002c7c; margin-top: 20px">
            <p>{{ arquivosEnviados }} de 10 documentos enviados</p>
            <ul style="margin-top: 10px; padding-left: 20px">
              <li *ngFor="let arquivo of nomesArquivosEnviados; index as i" [attr.data-index]="i">
                {{ arquivo }}
                <em class="cursor-pointer fa fa-trash" (click)="removerDocumento(i)" title="Remover documento"></em>
              </li>
            </ul>
          </div>
        </div>
      </app-panel-custom>

      <app-panel-custom [title]="'Documentos Obrigatórios'" [color]="'blue'" *ngIf="isMicrocredito">
        <div class="row">
          <div class="col-xs-12">
            <app-upload-arquivos
              [documentos]="requiredDocuments"
              [idFicha]="proposta.id"
              [cliente]="proposta.cliente"
              [pr30]="true"
              [origem]="14"
              [showUploadedItens]="true"
              [centeredSendButton]="true"
              (pushDocumentacao)="onPushDocumentos($event)"
              [acceptFiles]="acceptFiles"
            ></app-upload-arquivos>
          </div>
        </div>
      </app-panel-custom>

      <app-panel-custom [title]="'Documentos Adicionais'" [color]="'blue'" *ngIf="isMicrocredito">
        <div class="row">
          <div class="col-xs-12">
            <app-upload-arquivos
              #documentosAdicionais
              [documentos]="documents"
              [idFicha]="proposta.id"
              [cliente]="proposta.cliente"
              [enableSendButton]="documentosAdicionais.hasFilesToUpload"
              [pr30]="true"
              [centeredSendButton]="true"
              [origem]="14"
              [showUploadedItens]="true"
              [acceptFiles]="acceptFiles"
            ></app-upload-arquivos>
          </div>
        </div>
      </app-panel-custom>

      <app-panel-custom [title]="tituloPainel" [color]="'blue'" *ngIf="isCP">
        <div>
          <div class="form-group">
            <div class="inputs">
              <label for="comoAjuda"></label>
              <select
                  class="form-control select-emprestimo"
                  name="comoAjuda"
                  appShowErrorMessages
                  requiredMessage="O campo Como esse empréstimo vai te ajudar? é obrigatório"
                  formControlName="comoAjuda"
                  required>
                <option value="" hidden selected>Selecione</option>
                <option value="Contratar Serviços">CONTRATAR SERVIÇOS</option>
                <option value="Empreender (comprar mercadorias/utensílios)">EMPREENDER (COMPRAR MERCADORIAS/UTENSÍLIOS)</option>
                <option value="Quitar dividas que estão atrasadas">QUITAR DÍVIDAS QUE ESTÃO ATRASADAS</option>
                <option value="Pagar as contas comuns">PAGAR AS CONTAS COMUNS</option>
                <option value="Outro">OUTRO</option>
              </select>
            </div>
          </div>
        </div>
      </app-panel-custom>

      <h2>Informações Adicionais</h2>
      <div class="textarea-observacoes white-box">
        <textarea
            rows="10"
            cols="90"
            maxlength="4000"
            name="observacoes"
            formControlName="observacoes"></textarea>
      </div>
    </div>
  </div>
</form>

<app-botao-navegacao
  (previous)="onClickPrevious()"
  (next)="onClickNext()"
  [previousShow]="true"
  [nextShow]="true"
  [nextEnabled]="canSkipStep || valid"
></app-botao-navegacao>
